import { Controller } from "@hotwired/stimulus"

// Submits a GET filter form as soon as one of its fields changes.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
